import classnames from 'classnames'
import { FC } from 'react'

type UploadPreviewPropsType = {
  className?: string
  previewImageUrl: string
  previewBtnCallback(e: React.MouseEvent<SVGSVGElement, MouseEvent>): void
  deleteBtnCallback(e: React.MouseEvent<SVGSVGElement, MouseEvent>): void
}

/**
 *
 * @param className?:  UploadPreview className
 * @param previewImageUrl:  Image preview URL address
 * @callback previewBtnCallback:  preview button Callback
 * @callback deleteBtnCallback:  preview button Callback
 * @returns
 */
const UploadPreview: FC<UploadPreviewPropsType> = ({
  className,
  previewImageUrl,
  previewBtnCallback,
  deleteBtnCallback,
}) => {
  return (
    <div
      className={classnames(
        'w-[220px] h-[158px] mt-8 bg-[rgba(255,255,255,0.8)] shadow-[0_16px_24px_1px_rgba(0,0,0,0.04)] rounded overflow-hidden relative group cursor-pointer',
        className,
      )}
    >
      <img
        src={previewImageUrl}
        alt={previewImageUrl}
        className="object-cover w-full h-full"
      />
      <div className="absolute top-0 w-full h-full hidden group-hover:flex group-hover:bg-[rgba(0,0,0,0.7)] items-center justify-center">
        <div className="flex h-8 text-[#BDBDBD]">
          <svg
            className="w-8 h-8"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
            strokeWidth={2}
            onClick={e => previewBtnCallback(e)}
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M15 12a3 3 0 11-6 0 3 3 0 016 0z"
            />
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z"
            />
          </svg>
          <svg
            className="w-8 h-8 ml-[10px]"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
            strokeWidth={2}
            onClick={deleteBtnCallback}
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M10 14l2-2m0 0l2-2m-2 2l-2-2m2 2l2 2m7-2a9 9 0 11-18 0 9 9 0 0118 0z"
            />
          </svg>
        </div>
      </div>
    </div>
  )
}

export default UploadPreview
